import React from "react";
import "./JibuUseCases.css";
import { FaShoppingCart, FaStethoscope, FaGraduationCap, FaLaptopCode, FaPiggyBank, FaHotel } from "react-icons/fa";

const useCases = [
  {
    icon: <FaShoppingCart />,
    title: "E-commerce",
    description: "Answer product FAQs, track orders, and recommend products in real time.",
  },
  {
    icon: <FaStethoscope />,
    title: "Healthcare",
    description: "Let patients book appointments, receive reminders, and ask medical queries securely.",
  },
  {
    icon: <FaGraduationCap />,
    title: "Education",
    description: "Provide course details, handle admissions, and support students 24/7.",
  },
  {
    icon: <FaLaptopCode />,
    title: "Tech & SaaS",
    description: "Onboard users, answer support tickets, and automate demos or product tours.",
  },
  {
    icon: <FaPiggyBank />,
    title: "Finance",
    description: "Qualify leads, offer account information, and provide chatbot-driven advice.",
  },
  {
    icon: <FaHotel />,
    title: "Hospitality",
    description: "Book rooms, provide concierge service, and upsell with personalized offers.",
  },
];

const JibuUseCases = ({ isDarkMode }) => {
  return (
    <section className={`jibu-use-cases ${isDarkMode ? "dark-mode" : "light-mode"}`}>
      <h2>Who Is JibuBot For?</h2>
      <p className="subtext">Powerful, flexible, and tailored for every industry.</p>

      <div className="use-case-list">
        {useCases.map((useCase, index) => (
          <div
            className={`use-case-item ${index % 2 !== 0 ? "reverse" : ""}`}
            key={index}
          >
            <div className="icon-wrapper">{useCase.icon}</div>
            <div className="text-wrapper">
              <h3>{useCase.title}</h3>
              <p>{useCase.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default JibuUseCases;
